<template>
<div>
  <el-row slot="perfHeader" class="title-bar" type="flex"  justify="space-between" >
    <div class="title-h3">Cisco +</div>
    <el-col :span="6" class="btn-group-right">
      <el-button size="small" @click="exportCiscoInfoList()"><img src="@/assets/img/icons/excel.png" style="position:relative;top:3px;left:-2px"> 엑셀출력</el-button>
    </el-col>
  </el-row>
  <hr class="mr-b20">
  <!-- CDP 정보 -->
  <div class="mr-b20">
    <el-row type="flex" class="title-bar" justify="space-between">
      <div class="title-h4 tit">CDP 정보</div>
      <div>
        <span class="mr-r15">  최근 수집시간 : <em>{{cdpReloadTime}}</em></span>
        <el-button size="small" @click="loadCdpInfo()" type="primary">CDP 정보 갱신</el-button>
        <w-header-search-button @click="cdpShowSearchTool = !cdpShowSearchTool"></w-header-search-button>
      </div>
    </el-row>
    <el-table-wrapper :data="dataList.cdpData" :column-default="columnDefault" :columns="cdpColumns" :pagination="false" :show-custom-header="true" :show-search-tool="cdpShowSearchTool" style="width:100%;">
    </el-table-wrapper>
  </div>
  <!-- 플래시 풀 -->
  <div class="mr-b20">
    <el-row type="flex" class="title-bar" justify="space-between">
      <div class="title-h4 tit">플래시 풀</div>
      <div>
        <span class="mr-r15">최근 수집시간 : <em>{{flashReloadTime}}</em></span>
        <el-button size="small" @click="loadFlashInfo()" type="primary">플래시 풀 정보 갱신</el-button>
        <w-header-search-button @click="flashShowSearchTool = !flashShowSearchTool"></w-header-search-button>
      </div>
    </el-row>
    <el-table-wrapper :data="dataList.flashData" :column-default="columnDefault" :columns="flashColumns" :pagination="false" :show-custom-header="true" :show-search-tool="flashShowSearchTool" style="width:100%;">
    </el-table-wrapper>
  </div>
  <!-- 메모리 사용 정보 -->
  <div class="mr-b20">
    <el-row type="flex" class="title-bar" justify="space-between">
      <div class="title-h4 tit">메모리 사용 정보</div>
      <div>
        <span class="mr-r15">최근 수집시간 : <em>{{memReloadTime}}</em></span>
        <el-button size="small" @click="loadMemInfo()" type="primary">메모리 사용 정보 갱신</el-button>
        <w-header-search-button @click="memShowSearchTool = !memShowSearchTool"></w-header-search-button>
      </div>
    </el-row>
    <el-table-wrapper :data="dataList.memData" :column-default="columnDefault" :columns="memColumns" :pagination="false" :show-custom-header="true" :show-search-tool="memShowSearchTool" style="width:100%;">
    </el-table-wrapper>
  </div>
  <!-- 새시 정보 -->
  <div class="mr-b20">
    <el-row type="flex" class="title-bar" justify="space-between">
      <div class="title-h4 tit">새시 정보</div>
      <div>
        <span class="mr-r15">최근 수집시간 : <em>{{chassisReloadTime}}</em></span>
        <el-button size="small" @click="loadChassisInfo()" type="primary">새시 정보 갱신</el-button>
        <w-header-search-button @click="chassisShowSearchTool = !chassisShowSearchTool"></w-header-search-button>
      </div>
    </el-row>
    <el-table-wrapper :data="dataList.chassisData" :column-default="columnDefault" :columns="chassisColumns" :pagination="false" :show-custom-header="true" :show-search-tool="chassisShowSearchTool" style="width:100%;">
    </el-table-wrapper>
  </div>
  <!-- 모듈 정보 -->
  <div>
    <el-row type="flex" class="title-bar" justify="space-between">
      <div class="title-h4 tit">모듈 정보</div>
      <div>
        <span class="mr-r15">최근 수집시간 : <em>{{moduleReloadTime}}</em></span>
        <el-button size="small" @click="loadModuleInfo()" type="primary">모듈 정보 갱신</el-button>
        <w-header-search-button @click="moduleShowSearchTool = !moduleShowSearchTool"></w-header-search-button>
      </div>
    </el-row>
    <el-table-wrapper :data="dataList.moduleData" :column-default="columnDefault" :columns="moduleColumns" :pagination="false" :show-custom-header="true" :show-search-tool="moduleShowSearchTool" style="width:100%;">
    </el-table-wrapper>
  </div>
</div>
</template>

<script>
import netdeviceInfoAPI from '@/api/config/netdevice/netdevice-info';
import { getValueAfterCheckEmpty } from '@/utils/string';
import isNil from 'lodash/isNil';
import { convertValuByUnit } from '@/utils/number';
import { getDateToString } from '@/utils/date';
import { columnDefault } from '@/constants/table';

export default {
  name: 'WCiscoDeviceInfoNode',
  props: {
    activeTab: {
      type: String,
    },
    nodeParams: {
      type: Object,
    },
  },
  data() {
    return {
      columnDefault,
      cdpShowSearchTool: false,
      flashShowSearchTool: false,
      memShowSearchTool: false,
      chassisShowSearchTool: false,
      moduleShowSearchTool: false,
      cdpReloadTime: '-',
      flashReloadTime: '-',
      memReloadTime: '-',
      chassisReloadTime: '-',
      moduleReloadTime: '-',
      params: {
        objId: null,
      },
      dataList: {
        cdpData: null,
        flashData: null,
        memData: null,
        chassisData: null,
        cardData: null,
      },
      cdpColumns: [
        {
          prop: 'cdpCacheIfIndex',
          label: '인덱스',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'cdpCacheIfDesc',
          label: '인터페이스명',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'cdpCacheDeviceId',
          label: '연결 장비명',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'cdpCacheAddress',
          label: '연결 장비 IP',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'cdpCacheDevicePort',
          label: '연결 장비 포트',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'cdpCachePlatform',
          label: '연결 장비 모델링',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
      ],
      flashColumns: [
        {
          prop: 'ciscoFlashChipDescr',
          label: '장비명',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'ciscoFlashDeviceSize',
          label: '장비 크기',
          sortable: true,
          searchable: false,
          formatter: this.getConvertSizeByBData,
        },
        {
          prop: 'ciscoFlashDeviceMinPartitionSize',
          label: '최소 파티션 크기',
          sortable: true,
          searchable: false,
          formatter: this.getConvertSizeByBData,
        },
        {
          prop: 'ciscoFlashDeviceMaxPartitions',
          label: '최대 파티션 개수',
          sortable: true,
          searchable: false,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'ciscoFlashPartitionUseage',
          label: '사용량',
          sortable: true,
          searchable: false,
          formatter: this.getConvertSizeByBData,
        },
        {
          prop: 'ciscoFlashChipDescr',
          label: '설명',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
      ],
      memColumns: [
        {
          prop: 'ciscoMemoryPoolName',
          label: '메모리 종류',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'ciscoMemoryPoolTotal',
          label: '전체크기',
          sortable: true,
          searchable: false,
          formatter: this.getConvertSizeByBData,
        },
        {
          prop: 'ciscoMemoryPoolUsed',
          label: '사용량',
          sortable: true,
          searchable: false,
          formatter: this.getConvertSizeByBData,
        },
        {
          prop: 'ciscoMemoryPoolFree',
          label: '가용량',
          sortable: true,
          searchable: false,
          formatter: this.getConvertSizeByBData,
        },
        {
          prop: 'ciscoMemoryPoolLargestFree',
          label: '블록크기',
          sortable: true,
          searchable: false,
          formatter: this.getConvertSizeByBData,
        },
      ],
      chassisColumns: [
        {
          prop: 'chassisType',
          label: '모듈명',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'chassisVersion',
          label: '버전',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'chassisId',
          label: 'ID',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'processorRam',
          label: 'ROM 버전',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'romSysVersion',
          label: 'ROM Sys 버전',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'chassisSlots',
          label: '슬롯 수',
          sortable: true,
          searchable: false,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'chassisPartner',
          label: '제조사',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
      ],
      moduleColumns: [
        {
          prop: 'cardType',
          label: '카드 타입',
          width: 100,
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'cardDescr',
          label: '카드 설명',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'cardSerial',
          label: '시리얼',
          width: 100,
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'cardHwVersion',
          label: 'H/W 버전',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'cardSwVersion',
          label: 'S/W 버전',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'cardSlotNumber',
          label: '슬롯 번호',
          width: 100,
          sortable: true,
          searchable: false,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'cardIndexNumber',
          label: '카드 인덱스 번호',
          width: 100,
          sortable: true,
          searchable: false,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'cardOperStatus',
          label: '상태',
          width: 100,
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
      ],
    };
  },
  watch: {
    activeTab: {
      handler() {
        this.params.objId = this.nodeParams.objId;
        this.loadStore();
      },
    },
    nodeParams: {
      handler() {
        this.params.objId = this.nodeParams.objId;
        this.loadStore();
      },
      immediate: true,
    },
  },
  methods: {
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    exportCiscoInfoList() {
      netdeviceInfoAPI.exportCiscoInfoList(this.params);
    },
    loadCdpInfo() {
      const me = this;
      netdeviceInfoAPI.getCiscoCDPInformationList(this.params).then((response) => {
        if (response.data.success) {
          me.dataList.cdpData = response.data.data;
          me.cdpReloadTime = getDateToString(new Date().getTime());
        }
      });
    },
    loadFlashInfo() {
      const me = this;
      netdeviceInfoAPI.getCiscoFlashInformationList(this.params).then((response) => {
        if (response.data.success) {
          me.dataList.flashData = response.data.data;
          me.flashReloadTime = getDateToString(new Date().getTime());
        }
      });
    },
    loadMemInfo() {
      const me = this;
      netdeviceInfoAPI.getCiscoMemoryInformationList(this.params).then((response) => {
        if (response.data.success) {
          me.dataList.memData = response.data.data;
          me.memReloadTime = getDateToString(new Date().getTime());
        }
      });
    },
    loadChassisInfo() {
      const me = this;
      netdeviceInfoAPI.getCiscoChassisInformationList(this.params).then((response) => {
        if (response.data.success) {
          me.dataList.chassisData = response.data.data;
          me.chassisReloadTime = getDateToString(new Date().getTime());
        }
      });
    },
    loadModuleInfo() {
      const me = this;
      netdeviceInfoAPI.getCiscoCardsInformationList(this.params).then((response) => {
        if (response.data.success) {
          me.dataList.cardData = response.data.data;
          me.moduleReloadTime = getDateToString(new Date().getTime());
        }
      });
    },
    loadStore() {
      const me = this;
      if (!isNil(this.params) && this.activeTab === this.$options.name) {
        me.loadCdpInfo();
        me.loadFlashInfo();
        me.loadMemInfo();
        me.loadChassisInfo();
        me.loadModuleInfo();
      }
    },
    getConvertSizeByBData(row, column, value) {
      return convertValuByUnit(value, 'Byte', true, true, true);
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/config/node/netdevice/ciscodevice/index.vue